<template>
    <form  @submit.prevent="resetPassword" class="container p-0">
        <div class="col input-group--forgot-pass">
            <div class="input-group">
                <input
                    ref="password"
                    type="password"
                    class="form-control"
                    placeholder="Nueva Contraseña"
                    name="password"                    
                    v-model.lazy="password"
                    v-validate="'required|min:8'">
                <small class="text-validate">
                    {{ errors.first('password') }}
                </small>

                <input
                    type="password"
                    class="form-control"
                    placeholder="Confirmar Nueva Contraseña"
                    name="passwordConfirmation"
                    v-model.lazy="passwordConfirmation"
                    v-validate="'required|confirmed:password'"
                    data-vv-as="password">
                <small class="text-validate">
                    {{ errors.first('passwordConfirmation') }}
                </small>
            </div>

            <div class="input-group-append">
                <button  class="btn btn-outline-success">
                    {{ resetPasswordText }}                        
                    <i class="fas" :class="icon"></i>
                </button>
            </div>
        </div>
    </form>
</template>

<script>
const ERROR_DEFAULT = 'Hubo un error al cambiar la contraseña';

export default {
    name: 'ResetPasswordForm',
    data() {
        return {
            password: '', 
            passwordConfirmation: '',
            isLoading: false
        }
    },
    computed: {
        code() {
            return this.$route.params.code;
        },
        resetPasswordText() {
            return this.isLoading ? 'Cargando': 'Cambiar';
        },
        icon() {
            return this.isLoading ? 'fa-spinner' : 'fa-paper-plane'
        }
    },
    methods: {
        async resetPassword(){
            const isValid = await this.$validator.validateAll();
            if (isValid) {
                this.isLoading = true;
                axios.post(`auth/reset/${this.code}`, {
                    new_password: this.password,
                    verify_password: this.passwordConfirmation
                })
                .then(() => {
                    this.$emit('success');
                })
                .catch((e) => {
                    let error_msg = ERROR_DEFAULT;
                    if (e.response && e.response.data && e.response.data.errors.message) {
                        error_msg = e.response.data.errors.message;
                    }
                    this.$emit('error', error_msg);
                })
                .finally(() => {
                    this.isLoading = false;
                });
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.input-group--forgot-pass {
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 0px;

    input {
        font-size: 14px;
        padding: 1.50rem 1.75rem;
        width: 100%;
        margin: 20px 0 0;
        border-radius: .25rem !important;

        &::placeholder {
            color: #C2C1C0;
        }

        &:focus {
            border-color:$border-color-gray;
            box-shadow: 0 0 0 0.2rem #ededed5c;
        }
    }

    .input-group-append {
        .btn-outline-success {
            padding: 0.75rem 1.93rem;
            color: $white-color;
            border-color: $orange-color;
            background-color: $orange-color;
            box-shadow:none!important;
            font-weight:600;
            margin-top: 20px;

            &:hover {
                background-color: $primary-color;
                border-color: $primary-color;
                box-shadow: 0 0 0 0.2rem #1f9b905c!important;
            }

            &:active {
                background-color: $primary-color!important;
                border-color: $primary-color!important;
            }
        }
    }

    .text-validate {
        color: $red-color;
        margin:10px 0 0;
    }
    .input-validate {
        border:1px solid $red-color;
    }
}
// Medium devices (tablet 991px)
@media screen and (max-width:991px) {
    .input-group--forgot-pass {
        input {
            width: 100%;
            border-radius: 0;
        }

        .input-group-append {
            margin-left: 0px;
            width: 100%;
            border-radius: 0;

            .btn-outline-success{
                padding: 1rem 1.93rem;
                width: 100%;
                border-radius: 0;
                margin-top: 15px;
            }
        }
    }
}
</style>